import React, { useState, useEffect } from 'react';
import './App.css';
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import Registered from './components/Registered';
import Fraud from './components/Fraud';
import FileComplaint from './components/FileComplaint';
// Research Grants disabled
// import ResearchGrants from './components/ResearchGrants';
import Resources from './components/Resources';
import Contact from './components/Contact';
import ProviderRegistration from './components/ProviderRegistration';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import ProviderDetails from './components/ProviderDetails';
// Funding Form disabled
// import FundingForm from './components/FundingForm';
import UserLogin from './components/UserLogin';
import UserSignup from './components/UserSignup';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import UserDashboard from './components/UserDashboard';
// Thesis Verification disabled
// import ThesisVerification from './components/ThesisVerification';
// import ThesisVerificationPage from './components/ThesisVerificationPage';
// import ThesisReviewPage from './components/ThesisReviewPage';
import BillingPackages from './components/BillingPackages';
import PaymentHistory from './components/PaymentHistory';
import UserProfile from './components/UserProfile';

function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [viewProviderId, setViewProviderId] = useState(null);
  // Thesis Verification disabled
  // const [viewThesisBarcode, setViewThesisBarcode] = useState(null);
  // const [reviewThesisId, setReviewThesisId] = useState(null);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [showLoginSignup, setShowLoginSignup] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetPasswordToken, setResetPasswordToken] = useState(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  useEffect(() => {
    // Check if admin is logged in
    const adminAuth = localStorage.getItem('adminAuth');
    if (adminAuth) {
      try {
        const parsed = JSON.parse(adminAuth);
        if (parsed === true || parsed.authenticated === true) {
          setIsAdmin(true);
          setShowAdminPanel(true);
        }
      } catch (e) {
        if (adminAuth === 'true') {
          setIsAdmin(true);
          setShowAdminPanel(true);
        }
      }
    }

    // Check if user is logged in
    const userAuth = localStorage.getItem('userAuth');
    if (userAuth) {
      try {
        const user = JSON.parse(userAuth);
        setIsUserLoggedIn(true);
        setCurrentUser(user);
      } catch (e) {
        localStorage.removeItem('userAuth');
      }
    }

    // Check URL for admin access
    const params = new URLSearchParams(window.location.search);
    if (params.get('admin') === 'true') {
      setShowAdminPanel(true);
    }

    // Check URL for provider ID (from QR code scan)
    const providerId = params.get('provider');
    if (providerId) {
      setViewProviderId(providerId);
    }

    // Thesis Verification disabled

    // Check URL for password reset
    // Format: /reset-password?token=...
    if (window.location.pathname === '/reset-password') {
      const resetToken = params.get('token');
      if (resetToken) {
        setResetPasswordToken(resetToken);
      }
    }

    // Thesis Verification disabled - admin review page
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close user dropdown if clicking outside
      if (showUserDropdown && !event.target.closest('.user-dropdown-container')) {
        setShowUserDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserDropdown]);

  const handleUserLogin = (user) => {
    setIsUserLoggedIn(true);
    setCurrentUser(user);
    setShowLoginSignup(false);
    setActiveTab('home');

    // If the logged-in user is an admin, auto-route to admin dashboard
    // (adminAuth/adminToken are set by UserLogin.js after admin/login call)
    if (user && user.role === 'admin') {
      setIsAdmin(true);
      setShowAdminPanel(true);
    }
  };

  const handleUserLogout = () => {
    localStorage.removeItem('userAuth');
    localStorage.removeItem('adminAuth');
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setIsUserLoggedIn(false);
    setCurrentUser(null);
    setIsAdmin(false);
    setShowAdminPanel(false);
    setActiveTab('home');
  };

  const handleSignupSuccess = () => {
    setShowSignup(false);
    alert('Account created successfully! Please login.');
  };

  // Protected tabs that require login
  const protectedTabs = ['complaint', 'resources', 'register-provider', 'dashboard', 'billing', 'payment-history', 'profile'];

  const handleTabClick = (tab) => {
    if (protectedTabs.includes(tab) && !isUserLoggedIn) {
      setShowLoginSignup(true);
      setShowSignup(false);
    } else {
      setActiveTab(tab);
      setShowUserDropdown(false); // Close dropdown when navigating
    }
  };

  // Thesis Verification disabled - review and verification pages removed

  // Show provider details if provider ID is in URL
  if (viewProviderId) {
    return (
      <div className="App">
        <header className="header" style={{ position: 'relative' }}>
          <div style={{ position: 'relative', padding: '15px 10px 10px 10px' }}>
            <h1 style={{
              margin: 0,
              textAlign: 'center',
              fontSize: window.innerWidth <= 768 ? '16px' : '32px',
              padding: window.innerWidth <= 768 ? '5px 10px' : '0',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>
              GLOBAL RESEARCH ORGANISATION
            </h1>
          </div>
        </header>
        <main className="content">
          <ProviderDetails providerId={viewProviderId} />
          <div style={{ textAlign: 'center', marginTop: '30px', padding: '0 20px' }}>
            <button
              onClick={() => {
                setViewProviderId(null);
                window.history.pushState({}, '', window.location.pathname);
              }}
              style={{
                backgroundColor: '#3498db',
                color: 'white',
                border: 'none',
                padding: '12px 30px',
                borderRadius: '5px',
                fontSize: '16px',
                cursor: 'pointer',
                width: window.innerWidth <= 768 ? '100%' : 'auto',
                maxWidth: '300px'
              }}
            >
              Back to Home
            </button>
          </div>
        </main>
      </div>
    );
  }

  // Show reset password page (from email link)
  if (resetPasswordToken) {
    return (
      <ResetPassword
        token={resetPasswordToken}
        onBackToLogin={() => {
          setResetPasswordToken(null);
          setShowLoginSignup(true);
          setShowForgotPassword(false);
          window.history.pushState({}, '', '/');
        }}
      />
    );
  }

  // Show login/signup if requested
  if (showLoginSignup && !isUserLoggedIn) {
    if (showForgotPassword) {
      return (
        <ForgotPassword
          onBackToLogin={() => setShowForgotPassword(false)}
        />
      );
    } else if (showSignup) {
      return (
        <UserSignup
          onSignupSuccess={handleSignupSuccess}
          onSwitchToLogin={() => setShowSignup(false)}
          onCancel={() => setShowLoginSignup(false)}
        />
      );
    } else {
      return (
        <UserLogin
          onLogin={handleUserLogin}
          onSwitchToSignup={() => setShowSignup(true)}
          onSwitchToForgotPassword={() => setShowForgotPassword(true)}
          onCancel={() => setShowLoginSignup(false)}
        />
      );
    }
  }

  // Show admin panel if requested
  if (showAdminPanel) {
    if (isAdmin) {
      return (
        <AdminDashboard
          onLogout={() => {
            localStorage.removeItem('adminAuth');
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            localStorage.removeItem('userAuth');
            setIsAdmin(false);
            setShowAdminPanel(false);
            setIsUserLoggedIn(false);
            setCurrentUser(null);
            setShowLoginSignup(true);
            setActiveTab('home');
          }}
        />
      );
    } else {
      return (
        <AdminLogin
          onLogin={() => {
            setIsAdmin(true);
          }}
        />
      );
    }
  }

  return (
    <div className="App">
      <header className="header" style={{ position: 'relative' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', paddingLeft: '20px', paddingRight: '20px' }}>
          {/* Row 1: Website Title */}
          <div style={{ padding: '20px 0 10px 0' }}>
            <h1 style={{ margin: 0, textAlign: 'center' }}>GLOBAL RESEARCH ORGANISATION</h1>
          </div>

          {/* Row 2: User Controls */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: '10px', position: 'relative' }}>
            {isUserLoggedIn ? (
              <div
                className="user-dropdown-container"
                style={{ position: 'relative', display: 'inline-block' }}
              >
                <button
                  onClick={() => setShowUserDropdown(!showUserDropdown)}
                  style={{
                    backgroundColor: '#667eea',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <i className="fas fa-user-circle" style={{ fontSize: '18px' }}></i>
                  <span>{currentUser?.name}</span>
                  <span style={{ fontSize: '12px' }}>▾</span>
                </button>
                {showUserDropdown && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      right: 0,
                      backgroundColor: 'white',
                      boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                      borderRadius: '8px',
                      minWidth: '220px',
                      zIndex: 1000,
                      overflow: 'hidden',
                      marginTop: '2px'
                    }}
                  >
                    <button
                      onClick={() => handleTabClick('profile')}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        width: '100%',
                        padding: '14px 20px',
                        border: 'none',
                        backgroundColor: activeTab === 'profile' ? '#f8f9fa' : 'white',
                        color: '#2c3e50',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        borderBottom: '1px solid #ecf0f1',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => { e.target.style.backgroundColor = '#f0f3ff'; e.target.style.color = '#667eea'; }}
                      onMouseLeave={(e) => { e.target.style.backgroundColor = activeTab === 'profile' ? '#f8f9fa' : 'white'; e.target.style.color = '#2c3e50'; }}
                    >
                      <i className="fas fa-user" style={{ width: '20px', fontSize: '16px' }}></i>
                      <span>My Profile</span>
                    </button>
                    <button
                      onClick={() => handleTabClick('dashboard')}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        width: '100%',
                        padding: '14px 20px',
                        border: 'none',
                        backgroundColor: activeTab === 'dashboard' ? '#f8f9fa' : 'white',
                        color: '#2c3e50',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        borderBottom: '1px solid #ecf0f1',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => { e.target.style.backgroundColor = '#f0f3ff'; e.target.style.color = '#667eea'; }}
                      onMouseLeave={(e) => { e.target.style.backgroundColor = activeTab === 'dashboard' ? '#f8f9fa' : 'white'; e.target.style.color = '#2c3e50'; }}
                    >
                      <i className="fas fa-tachometer-alt" style={{ width: '20px', fontSize: '16px' }}></i>
                      <span>Dashboard</span>
                    </button>
                    {/* Billing & Packages and Payment History hidden */}
                    <button
                      onClick={handleUserLogout}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        width: '100%',
                        padding: '14px 20px',
                        border: 'none',
                        backgroundColor: 'white',
                        color: '#e74c3c',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => { e.target.style.backgroundColor = '#fee'; }}
                      onMouseLeave={(e) => { e.target.style.backgroundColor = 'white'; }}
                    >
                      <i className="fas fa-sign-out-alt" style={{ width: '20px', fontSize: '16px' }}></i>
                      <span>Logout</span>
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <button
                onClick={() => { setShowLoginSignup(true); setShowSignup(false); }}
                style={{
                  backgroundColor: '#27ae60',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 8px rgba(39, 174, 96, 0.3)',
                  transition: 'all 0.3s ease'
                }}
              >
                Login
              </button>
            )}
          </div>
        </div>
        <nav className="nav" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', paddingTop: '10px' }}>
          <button
            className={activeTab === 'home' ? 'active' : ''}
            onClick={() => handleTabClick('home')}
          >
            Home
          </button>
          <button
            className={activeTab === 'about' ? 'active' : ''}
            onClick={() => handleTabClick('about')}
          >
            About Us
          </button>
          <button
            className={activeTab === 'registered' ? 'active' : ''}
            onClick={() => handleTabClick('registered')}
          >
            Verified Providers
          </button>
          <button
            className={activeTab === 'fraud' ? 'active' : ''}
            onClick={() => handleTabClick('fraud')}
          >
            Fraud Alert
          </button>
          <button
            className={activeTab === 'complaint' ? 'active' : ''}
            onClick={() => handleTabClick('complaint')}
          >
            Report Fraud
          </button>
          {/* Services dropdown disabled - Research Grants, Funding Form, Thesis Verification */}
          <button
            className={activeTab === 'resources' ? 'active' : ''}
            onClick={() => handleTabClick('resources')}
          >
            Resources
          </button>
          <button
            className={activeTab === 'register-provider' ? 'active' : ''}
            onClick={() => handleTabClick('register-provider')}
          >
            Provider Registration
          </button>
          <button
            className={activeTab === 'contact' ? 'active' : ''}
            onClick={() => handleTabClick('contact')}
          >
            Contact
          </button>
        </nav>
      </header>
      <main className="content">
        {activeTab === 'home' && <Home setActiveTab={setActiveTab} />}
        {activeTab === 'about' && <AboutUs />}
        {activeTab === 'registered' && <Registered />}
        {activeTab === 'fraud' && <Fraud />}
        {activeTab === 'complaint' && <FileComplaint currentUser={currentUser} />}
        {activeTab === 'resources' && <Resources />}
        {activeTab === 'register-provider' && <ProviderRegistration currentUser={currentUser} />}
        {activeTab === 'contact' && <Contact />}
        {activeTab === 'dashboard' && <UserDashboard currentUser={currentUser} />}
        {activeTab === 'profile' && <UserProfile />}
        {activeTab === 'billing' && <BillingPackages />}
        {activeTab === 'payment-history' && <PaymentHistory />}
      </main>

      {/* Admin Access Link (Hidden in footer or accessible via direct URL) */}
      <div style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        opacity: '0.3',
        transition: 'opacity 0.3s'
      }}
      onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
      onMouseLeave={(e) => e.currentTarget.style.opacity = '0.3'}
      >
        <button
          onClick={() => setShowAdminPanel(true)}
          style={{
            backgroundColor: '#2c3e50',
            color: 'white',
            border: 'none',
            padding: '8px 15px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          Admin
        </button>
      </div>
    </div>
  );
}

export default App;
